import styles from '../index.less';

const EmptyList = () => {
  return (
    <div className={styles.emptyList}>
      <p className={styles.emptyTitle}>您暂未上机9周年活动设备</p>
      <p className={styles.emptyText}>
        若您已绑定设备，可能会有2-3天更新延迟，不影响在线打卡及权益发放
      </p>
    </div>
  );
};
export default EmptyList;
